import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
export function ReadingProgress() {
  const {
    scrollYProgress
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 28,
    restDelta: 0.001
  });
  return <motion.div aria-hidden="true" style={{
    scaleX
  }} className="fixed inset-x-0 top-0 z-50 h-[2px] origin-left bg-gold" data-id="element-81" data-mp="3g3buqgfg8506" />;
}